
(function($) {
  'use strict';
 
  //console.log('tab-state');

  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    //e.target // newly activated tab
    //e.relatedTarget // previous active tab

    var show_control = $(e.target).attr('aria-controls' ) ;
    var hide_control = $(e.relatedTarget).attr('aria-controls' ) ;

    var states = {};
    
    try {
      states = JSON.parse( $.cookie('tab-states') );
    } catch (ex) {

    }
    //console.log( states );
    if ( !states || !(states instanceof Object) ) { states = {}; }
    states[show_control] = true;
    if ( hide_control )  {
      states[hide_control] = false;
    }
    $.cookie('tab-states', JSON.stringify(states));



  });

})(jQuery);
